export default "__VITE_ASSET__FoQ1mGon__"